import { render } from "./deviceAdd.vue?vue&type=template&id=4252b7f5&scoped=true"
import script from "./deviceAdd.vue?vue&type=script&lang=js"
export * from "./deviceAdd.vue?vue&type=script&lang=js"

import "./deviceAdd.vue?vue&type=style&index=0&id=4252b7f5&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4252b7f5"]])

export default __exports__